import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BreadcrumbSection() {
  return <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-1994">
      <a href="/EDMNetwork.html" className="hover:text-orange transition-colors" data-id="element-1995">
        EDM Network
      </a>
      <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-1996" />
      <span className="text-navy font-semibold" data-id="element-1997">Wire EDM Traditional</span>
    </div>;
}